import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./styles.css";
import { initInteractiveHover } from "./lib/interactiveHover";
import { AuthProvider } from "./auth/AuthContext";
import { ToastProvider } from "./lib/toast";
import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./components/RequireAuth";
import { Home } from "./pages/Home";
import { AuthCallback } from "./pages/AuthCallback";
import { Profile } from "./pages/Profile";
import { Teams } from "./pages/Teams";
import { TeamDetail } from "./pages/TeamDetail";
import { JoinTeam } from "./pages/JoinTeam";
import { Meets } from "./pages/Meets";
import { MyMeets } from "./pages/MyMeets";
import { MeetDetailPage } from "./pages/MeetDetail";
import { CreateMeet } from "./pages/CreateMeet";
import { InviteLanding } from "./pages/InviteLanding";
import { Discover } from "./pages/Discover";
import { DiscoveryReview } from "./pages/DiscoveryReview";
import { DiscoverySources } from "./pages/DiscoverySources";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { Onboarding } from "./pages/Onboarding";
import { CoachDashboard } from "./pages/CoachDashboard";
import { WrestlerRecord } from "./pages/WrestlerRecord";
import { Standings } from "./pages/Standings";
import { AdminUsers } from "./pages/AdminUsers";
import { AdminActivity } from "./pages/AdminActivity";

const protect = (el: React.ReactNode) => <RequireAuth>{el}</RequireAuth>;

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/auth/callback", element: <AuthCallback /> },
      // Public landing pages
      { path: "/i/:token", element: <InviteLanding /> },
      { path: "/join/:code", element: <JoinTeam /> },
      { path: "/privacy", element: <Privacy /> },
      { path: "/terms", element: <Terms /> },
      // Protected
      { path: "/profile", element: protect(<Profile />) },
      { path: "/record", element: protect(<WrestlerRecord />) },
      { path: "/standings", element: protect(<Standings />) },
      { path: "/onboarding", element: protect(<Onboarding />) },
      { path: "/dashboard", element: protect(<CoachDashboard />) },
      { path: "/teams", element: protect(<Teams />) },
      { path: "/teams/:teamId", element: protect(<TeamDetail />) },
      { path: "/meets", element: protect(<MyMeets />) },
      { path: "/meets/browse", element: protect(<Meets />) },
      { path: "/meets/new", element: protect(<CreateMeet />) },
      { path: "/meets/:meetId", element: protect(<MeetDetailPage />) },
      { path: "/discover", element: protect(<Discover />) },
      { path: "/discovery/review", element: protect(<DiscoveryReview />) },
      { path: "/discovery/sources", element: protect(<DiscoverySources />) },
      { path: "/admin/users", element: protect(<AdminUsers />) },
      { path: "/admin/activity", element: protect(<AdminActivity />) },
    ],
  },
]);

initInteractiveHover();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AuthProvider>
  </StrictMode>,
);
